import React from 'react';
import { IconBrandInstagram, IconBolt } from '@tabler/icons-react';
import useInstagramStatus from './useStatus';

const InstagramCard = ({ agentId, context }) => {
  const status = useInstagramStatus(agentId);

  const handleConnect = (e) => {
    e.stopPropagation();
    if (context?.onConnect) context.onConnect('instagram');
  };

  const handleConfigure = (e) => {
    e.stopPropagation();
    if (context?.onSelect) context.onSelect('instagram');
  };

  const cardClass = [
    'channel-card',
    status.isConnected && 'channel-card--connected',
    status.alertSeverity === 'error' && 'channel-card--error',
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClass}>
      <div
        className="channel-card__icon"
        style={{
          background: 'linear-gradient(135deg, #E4405F 0%, #C13584 100%)',
          color: '#fff',
        }}
      >
        <IconBrandInstagram size={22} />
      </div>

      <div className="channel-card__body">
        <h5 className="channel-card__name">
          Instagram
          {status.alertSeverity === 'error' && (
            <IconBolt size={14} style={{ color: '#dc2626' }} />
          )}
        </h5>
        <p className="channel-card__description">
          DMs via Meta Graph API.
        </p>

        {status.isLoading && (
          <p className="channel-card__summary" style={{ color: '#9ca3af' }}>
            Carregando status...
          </p>
        )}

        {!status.isLoading && status.isConnected && (
          <p className="channel-card__summary">{status.summary}</p>
        )}
      </div>

      <div className="channel-card__footer">
        {status.isConnected ? (
          <>
            <span
              className={`channel-card__status-pill channel-card__status-pill--${status.statusVariant}`}
            >
              {status.statusLabel}
            </span>
            <button
              type="button"
              className="channel-card__cta"
              onClick={handleConfigure}
              style={{ background: '#374151' }}
            >
              Gerenciar
            </button>
          </>
        ) : (
          <>
            <span />
            <button type="button" className="channel-card__cta" onClick={handleConnect}>
              Conectar
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default InstagramCard;
